import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { FaArrowUp, FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './style.css'

const Scrollbar = () => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    // Get current language directly from i18n (source of truth)
    const currentLanguage = i18n.language || 'en';

    // Sync document lang attribute with i18n
    useEffect(() => {
        document.documentElement.lang = currentLanguage;
    }, [currentLanguage]);

    const toggleLanguage = () => {
        const newLang = currentLanguage === 'en' ? 'ar' : 'en';
        const isLandingPage = location.pathname === '/' || location.pathname === '/en' || location.pathname === '/ar';

        if (isLandingPage) {
            // Navigate to localized URL for SEO (HomePage will sync i18n)
            navigate(`/${newLang}`);
        } else {
            // For other pages, use i18n and reload
            localStorage.setItem('language', newLang);
            document.documentElement.lang = newLang;
            i18n.changeLanguage(newLang);
            window.location.reload();
        }
    };

    return (
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li>
                        <button
                            onClick={toggleLanguage}
                            className="language-toggle-btn"
                            aria-label={currentLanguage === 'en' ? 'Switch to Arabic' : 'Switch to English'}
                            title={currentLanguage === 'en' ? 'Switch to Arabic' : 'Switch to English'}
                        >
                            <FaGlobe />
                        </button>
                    </li>
                    <li><AnchorLink href='#scrool'><FaArrowUp /></AnchorLink></li>
                </ul>
            </div>
        </div>

    )
}

export default Scrollbar;